import styled from "styled-components";
import { colors } from "../../components/helpers/functions";

export const WrapperStyled = styled.div`
    .home{
        width: 100vw;
        height: 100vh;
        background-image: url("/images/background_home.jpg");
        background-position: 50% 50%;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .home_top{

        }
        .home_middle{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .home_bottom{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .direccion{
                padding-bottom: 25vw;
            }
        }
        .logo{
            /* margin-top: 20vw; */
            width: 230px;
            margin-top: 25vw;
            img{
                float: left;
                width: 100%;
            }
        }
        .direccion{
            margin-top: 15px;
            font-size: 18px;
            font-weight: 700;
            color: #FFFFFF;
        }
        .email{
            margin-top: 25px;
            font-size: 16px;
            font-weight: 500;
            //color: #FFFFFF;
        }
    }

    .back_marron_tierra{
        background-color: rgba(${colors.marron_tierra}, 1);
    }
    .back_verde_brocoli{
        background-color: rgba(${colors.verde_brocoli}, 1);
    }
    .back_verde_acelga{
        background-color: rgba(${colors.verde_acelga}, 1);
    }
    .back_azul_agua{
        background-color: rgba(${colors.azul_agua}, 1);
    }
    .back_naranja_pimiento{
        background-color: rgba(${colors.naranja_pimiento}, 1);
    }
    .back_amarillo_banana{
        background-color: rgba(${colors.amarillo_banana}, 1);
    }
    .back_blanco_huevo{
        background-color: rgba(${colors.blanco_huevo}, 1);
    }
    .back_trebol{
        background-color: rgba(${colors.trebol}, 1);
    }

    .text_marron_tierra{
        color: rgba(${colors.marron_tierra}, 1);
    }
    .text_verde_brocoli{
        color: rgba(${colors.verde_brocoli}, 1);
    }
    .text_verde_acelga{
        color: rgba(${colors.verde_acelga}, 1);
    }
    .text_azul_agua{
        color: rgba(${colors.azul_agua}, 1);
    }
    .text_naranja_pimiento{
        color: rgba(${colors.naranja_pimiento}, 1);
    }
    .text_amarillo_banana{
        color: rgba(${colors.amarillo_banana}, 1);
    }
    .text_blanco_huevo{
        color: rgba(${colors.blanco_huevo}, 1);
    }
    .text_trebol{
        color: rgba(${colors.trebol}, 1);
    }
    .wp_contact{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        /* margin-top: 15px; */
        font-size: 20px;
        line-height: 20px;
        font-weight: 700;
        color: #FFFFFF;
        height: 40px;
        width: 40px;
        background-color: #25D366!important;
        padding: 0!important;
        border-radius: 50%;
        cursor: pointer;
        .wp_icon{
            display: flex;
            font-size: 23px;
            line-height: 23px;
            padding-top: 2px;
        }
        .wp_numero{
            margin-left: 5px;
        }
        &:hover{
             background-color: rgba(${colors.naranja_pimiento}, .5);
        }
    }
    .inner_menu{
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        .inner_menu_item{
            color: #FFFFFF;
            font-size: 18px;
            font-weight: 600;
            cursor: pointer;
            background-color: rgba(${colors.azul_agua}, .95);
            padding: 8px 23px;
            &:hover{
                background-color: rgba(${colors.azul_agua}, .5);
            }
        }
    }
    .vivi{
        color: #FFFFFF;
        font-size: 5.5vw;
        line-height: 6.5vw;
        font-weight: 600;
        text-align: center;
        margin-bottom: 15vw;
    }

    @media (min-width: 1201px) {
        .vivi{
            font-size: 45px;
            line-height: 55px;
            margin-bottom: 100px;
        }
        .home{
            .logo{
                margin-top: 130px;
            }
        }
    }
`